import { render } from "./illuminationControllerDaliDim.vue?vue&type=template&id=7e6d6c95&scoped=true"
import script from "./illuminationControllerDaliDim.vue?vue&type=script&lang=js"
export * from "./illuminationControllerDaliDim.vue?vue&type=script&lang=js"

import "./illuminationControllerDaliDim.vue?vue&type=style&index=0&id=7e6d6c95&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\horva\\Documents\\nodejs\\production\\enat05\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e6d6c95"]])

export default __exports__